import { FC, ReactNode } from "react";
import { useIsModuleConnected } from "./use-is-module-connected";
import { Module } from "gql/graphql";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export const RestrictionFactory = (moduleId: Module) => {
  function ModuleConnectedOr({
    alternative,
    children,
  }: {
    children: ReactNode;
    alternative: ReactNode;
  }) {
    const moduleConnected = useIsModuleConnected(moduleId);

    return moduleConnected ? children : alternative;
  }

  function ModuleOr404({ children }: { children: ReactNode }) {
    return (
      <ModuleConnectedOr alternative={<ToPageNotFound />}>
        {children}
      </ModuleConnectedOr>
    );
  }

  function WithModuleOr404<T extends object>(Component: FC<T>) {
    function ModuleOrNotFound(props: T) {
      return (
        <ModuleOr404>
          <Component {...props} />
        </ModuleOr404>
      );
    }

    return ModuleOrNotFound;
  }

  function ModuleOrNull({ children }: { children: ReactNode }) {
    return <ModuleConnectedOr alternative={null}>{children}</ModuleConnectedOr>;
  }

  function WithModuleOrNull<T extends object>(Component: FC<T>) {
    return function ModuleOrNothing(props: T) {
      return (
        <ModuleOrNull>
          <Component {...props} />
        </ModuleOrNull>
      );
    };
  }

  return {
    Module: moduleId,
    ModuleOr404,
    ModuleOrNull,
    WithModuleOr404,
    WithModuleOrNull,
  };
};
